module.exports = __webpack_public_path__ + "img/antes_despues_312.137ecc30.png";